export default __webpack_public_path__ + "static/media/nmb.d981539a.png";